import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PagedChatMetaData } from "@shared/models/paged-chat-metadata.model";
import { ChatMetaData } from "@shared/models/chat-metadata.model";
import { sortDirection } from "@shared/models/sort-direction.model";
import { sort } from "@shared/models/sort";

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.css']
})
export class DataTableComponent implements OnChanges {
  @Input() records!: PagedChatMetaData
  @Input() sort: sortDirection = "DESC";
  @Input() typeSort: sort | undefined;

  readonly categories = [
    {id: 'today', label: 'Today', records: [] as ChatMetaData[]},
    {id: 'yesterday', label: 'Yesterday', records: [] as ChatMetaData[]},
    {id: 'last-week', label: 'Last Week', records: [] as ChatMetaData[]},
    {id: 'last-month', label: 'Last Month', records: [] as ChatMetaData[]},
    {id: 'all', label: 'All', records: [] as ChatMetaData[]}
  ];

  recordCategories = [...this.categories];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['records']) {
      this.sortRecordCategories();
      this.recordCategories.forEach(category => category.records = []);
      changes['records'].currentValue.content.forEach((record: ChatMetaData) => {
        const today = new Date();
        const yesterday = new Date(new Date().setDate(today.getDate() - 1));
        const lastWeek = new Date(new Date(new Date().setDate(today.getDate() - 7)).toDateString());
        const lastMonth = new Date(new Date(new Date().setMonth(today.getMonth() - 1)).toDateString());
        let updatedAt = record.updatedAt;

        if (updatedAt.toDateString() === today.toDateString()) {
          this.pushRecordToCategory('today', record);
        } else if (updatedAt.toDateString() === yesterday.toDateString()) {
          this.pushRecordToCategory('yesterday', record);
        } else if (updatedAt >= lastWeek) {
          this.pushRecordToCategory('last-week', record);
        } else if (updatedAt >= lastMonth) {
          this.pushRecordToCategory('last-month', record);
        } else {
          this.pushRecordToCategory('all', record);
        }
      });
    }
  }

  removeRecord(list: ChatMetaData[], record: ChatMetaData) {
    const index = list.indexOf(record);
    list.splice(index, 1);
  }

  private sortRecordCategories(): void {
    this.recordCategories = this.sort === 'DESC'
      ? this.categories
      : [...this.categories].reverse();
  }

  private pushRecordToCategory(categoryId: string, record: ChatMetaData): void {
    const category = this.recordCategories.find(cat => cat.id === categoryId);
    if (category) {
      category.records.push(record);
    }
  }
}
